export default "__VITE_ASSET__BQSEztVV__"